import { m } from "@/paraglide/messages.js";

const PRICE_LABEL_MAP: Record<string, () => string> = {
  "A single 30 minute lesson": () => m.prices_label_single_30(),
  "Series of 5, 30 minute lessons": () => m.prices_label_series_5_30(),
  "Series of 10, 30 minute lessons": () => m.prices_label_series_10_30(),
  "Series of 15, 30 minute lessons": () => m.prices_label_series_15_30(),
  "A single 1 hour lesson": () => m.prices_label_single_60(),
  "A single 60 minute lesson": () => m.prices_label_single_60(),
  "Series of 5, 1 hour lessons": () => m.prices_label_series_5_60(),
  "Series of 5, 60 minute lessons": () => m.prices_label_series_5_60(),
  "Series of 10, 1 hour lessons": () => m.prices_label_series_10_60(),
  "Series of 10, 60 minute lessons": () => m.prices_label_series_10_60(),
  "Small Bucket": () => m.prices_label_bucket_small(),
  "Medium Bucket": () => m.prices_label_bucket_medium(),
  "Large Bucket": () => m.prices_label_bucket_large(),
  "Extra Large Bucket": () => m.prices_label_bucket_xl(),
  "Jumbo Bucket": () => m.prices_label_bucket_jumbo(),
};

/** Map known English site_prices / marketing labels to the active locale. */
export function localizePriceLabel(label: string): string {
  const translate = PRICE_LABEL_MAP[label.trim()];
  return translate ? translate() : label;
}
